module.exports = __webpack_public_path__ + "media/images/Tiled-Church-montage-defocus-opt-6eb1fe96e90253be8d0f290655f87a3a.jpg";